/**
 * Before may 2024 all cross-brace dummy colliders was called "wide-dummy-collider" or "narrow-dummy-collider".
 * After this they also got the height of the section in the name so this interceptor replaces the old
 * dummy colliders with the new if opening a VPC code saved before this change.
 * We have now also renamed the dummy-colliders for corner sections to align with the other sections.
 */
export default class ReplaceDummyColliderInterceptor {
    constructor(productCatalog) {
        this.productDTOs = productCatalog.productDTOs();
    }
    beforeDeserialize(json) {
        const data = JSON.parse(json);
        const entities = data.entities;
        const replacedEntities = entities.map((entity) => {
            if (entity.ref === 'wide-dummy-collider' ||
                entity.ref === 'narrow-dummy-collider' ||
                entity.ref === 'narrow-corner-dummy-collider' ||
                entity.ref === 'wide-corner-dummy-collider') {
                const section = entities.find((e) => e.id === entity.parent);
                const sectionProduct = section && this.productDTOs.find(product => product.id === section.ref);
                return sectionProduct
                    ? { ...entity, ref: `${entity.ref}-${sectionProduct.template.comSize.height / 10}` }
                    : entity;
            }
            return entity;
        });
        return JSON.stringify({ ...data, entities: replacedEntities });
    }
    beforeParsingComponents() { }
    beforeBuildingEntities() { }
    afterDeserializeComplete() { }
}
//# sourceMappingURL=ReplaceDummyColliderInterceptor.js.map